import React, { useState, useEffect, useCallback } from 'react';
import './CreateCategories.css';
import Notification from '../../Notification/Notification';

const apiUrl = process.env.REACT_APP_API_URL;

function CreateCategories({ selectedCategory, onSaveSuccess, onCancel }) {
  const [categories, setCategories] = useState([]);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const [isParent, setIsParent] = useState(false);

  const [categoryName, setCategoryName] = useState('');
  const [description, setDescription] = useState('');
  const [editMode, setEditMode] = useState(false);
  const [isFormModified, setIsFormModified] = useState(false);
  const [isSubmittedSuccessfully, setIsSubmittedSuccessfully] = useState(false); // New state
  const [token] = useState(localStorage.getItem('token') || '');

  const fetchCategories = useCallback(() => {
    fetch(`${apiUrl}/categories`, {
      headers: { 'Authorization': `Bearer ${token}` }
    })
      .then((response) => response.json())
      .then((data) => setCategories(data))
      .catch((error) => console.error('Error fetching categories:', error));
  }, [token]);

  useEffect(() => {
    fetchCategories();
  }, [fetchCategories]);

  useEffect(() => {
    if (selectedCategory) {
      setCategoryName(selectedCategory.name);
      setDescription(selectedCategory.description);

      setIsParent(selectedCategory.is_parent || false);

      setEditMode(true);
      setIsSubmittedSuccessfully(false); // Reset on new selection
    } else {
      setEditMode(false);
      // When switching to create mode, clear fields and reset submission status
      setCategoryName('');
      setDescription('');

      setIsParent(false)

      setIsSubmittedSuccessfully(false);
    }
  }, [selectedCategory]);

  useEffect(() => {
    if (editMode) {
      const isModified =
        selectedCategory?.name !== categoryName ||
        selectedCategory?.description !== description ||
        !!selectedCategory?.is_parent !== !!isParent;
      setIsFormModified(isModified);
    } else {
      setIsFormModified(
        categoryName !== '' ||
        description !== '' ||
        isParent !== false
      );
    }
    // Reset isSubmittedSuccessfully if user starts typing after a successful submission
    if (isSubmittedSuccessfully && (categoryName !== '' || description !== '')) {
      setIsSubmittedSuccessfully(false);
    }
  }, [categoryName, description, isParent, editMode, selectedCategory, isSubmittedSuccessfully]);

  const handleSaveCategory = async () => {
    if (categoryName.trim() === '') {

      setError('Kategória neve szükséges!')
      return;
    }

    setError('');
    setSuccess('');

    const newCategory = {
      name: categoryName,
      description: description,
      parent_id: null,
      is_parent: isParent
    };

    const method = editMode ? 'PUT' : 'POST';
    const url = editMode ? `${apiUrl}/categories/${selectedCategory.id}` : `${apiUrl}/categories`;

    const response = await fetch(url, {
      method: method,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
      },
      body: JSON.stringify(newCategory),
    });

    if (response.ok) {
      //const savedCategory = await response.json();

      setSuccess(`Sikeresen mentettem a  ${newCategory.name} kategóriát`);
      setCategoryName('');
      setDescription('');
      setIsParent(false);
      setIsSubmittedSuccessfully(true); // Set to true on successful submission
      setCategories([...categories, newCategory])
      onSaveSuccess(); // Call in both edit and create mode
    } else {
      //alert('Hiba történt a kategória mentése során.');
      setError('Hiba történt a kategória mentése során.');
    }
  };

  return (
    <div className="create-categories">
      <h2>{editMode ? 'Kategória szerkesztése' : 'Kategória létrehozása'}</h2>

      <div>
        <label>Kategória név:</label>
        <input
          type="text"
          value={categoryName}
          onChange={(e) => setCategoryName(e.target.value)}
          placeholder="Új kategória neve"
        />
      </div>

      <div>
        <label>Kategória leírás:</label>
        <textarea
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          placeholder="Kategória leírása"
        />
      </div>

      <div>
        <label>
          Szülő kategória
          <input
            type="checkbox"
            checked={isParent}
            onChange={(e) => setIsParent(e.target.checked)}
          />

        </label>
      </div>

      <div className="button-group">
        <button
          onClick={handleSaveCategory}
          disabled={editMode
            ? !isFormModified
            : (categoryName.trim() === '' && !isSubmittedSuccessfully)} // Modified disabled logic
          style={{
            backgroundColor: (editMode ? isFormModified : (categoryName.trim() !== '' || isSubmittedSuccessfully)) ? '#4CAF50' : '#A5D6A7', // Zöld, ha engedélyezett
            color: 'white',
            cursor: (editMode ? isFormModified : (categoryName.trim() !== '' || isSubmittedSuccessfully)) ? 'pointer' : 'not-allowed'
          }}
        >
          {editMode ? 'Kategória mentése' : 'Kategória felvétele'}
        </button>

        <button
          onClick={onCancel}
          style={{
            backgroundColor: '#f44336', // Piros gomb
            color: 'white',
            marginLeft: '10px'
          }}
        >
          Mégse
        </button>
      </div>
      <Notification
        message={error || success}
        type={error ? 'error' : success ? 'success' : ''}
        onClose={() => {
          setError('');
          setSuccess('');
        }}
      />
    </div>
  );
}

export default CreateCategories;
